import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import styles from './Auth.module.css';

export default function Signup() {
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [error,    setError]    = useState('');
  const [success,  setSuccess]  = useState(false);
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8)  { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    const { error } = await supabase.auth.signUp({ email, password });
    if (error) setError(error.message);
    else setSuccess(true);
    setLoading(false);
  };

  if (success) return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>Run<span>Staff</span>Run</div>
        <div className="success-msg mt-16">
          Account created. Check your email to confirm your address, then sign in.
        </div>
        <p className={styles.switch} style={{ marginTop: 24 }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logo}>Run<span>Staff</span>Run</div>
        <h1 className={styles.heading}>Start your free trial</h1>
        <p className={styles.sub}>100 PA contacts included. No credit card required.</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          {error && <div className="error-msg">{error}</div>}
          <div className="form-group">
            <label>Work email address</label>
            <input
              className="form-input"
              type="email" required
              placeholder="you@company.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              className="form-input"
              type="password" required
              placeholder="At least 8 characters"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label>Confirm password</label>
            <input
              className="form-input"
              type="password" required
              placeholder="••••••••"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
            />
          </div>
          <button className="btn btn-primary btn-full" type="submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Free Account'}
          </button>
        </form>

        <p className={styles.switch}>
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
